import React, { FC } from 'react'

// MUI
import { Box, CardMedia, Typography } from '@mui/material'
import Masonry from '@mui/lab/Masonry'

// Common
import Fancybox from '@/components/common/fancy-app'

// Data
import { BedGallery, FancyAppsOptions } from '@/data'

// UI
import { DividerLine } from '@/ui'
import { GalleryHeadingTitle } from '../styles'

const BadGallerySection: FC = () => {
  return (
    <Box sx={{ mt: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <GalleryHeadingTitle>
          <Typography variant="body2" variantMapping={{ body2: 'span' }} className="firstHeadline" />{' '}
          <Typography variant="body2" variantMapping={{ body2: 'span' }} className="secondHeadline">
            Beds
          </Typography>
        </GalleryHeadingTitle>

        <DividerLine />
      </Box>

      <Fancybox options={FancyAppsOptions}>
        <Masonry columns={{ xs: 1, sm: 6, md: 4 }} spacing={0}>
          {BedGallery.map((bed, idx) => {
            return (
              <a data-fancybox="bed-gallery" data-caption={bed.title} href={bed?.imgPath} key={idx}>
                <CardMedia component="img" src={bed.imgPath} alt={bed.title} title={bed.title} />
              </a>
            )
          })}
        </Masonry>
      </Fancybox>
    </Box>
  )
}

export default BadGallerySection
